import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
    name: 'twoDecNumber',
    standalone: false
})
export class TwoDecNumberPipe implements PipeTransform {
    constructor(private decimalPipe: DecimalPipe) { }

    transform(value: string | number): string {
        if (Number.isInteger(+value)) {
            return '' + value;
        }
        return this.decimalPipe.transform(value, '0.2');
    }
}
